import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=db02b170&"
import script from "./PageSizeSelect.vue?vue&type=script&lang=js&"
export * from "./PageSizeSelect.vue?vue&type=script&lang=js&"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&id=db02b170&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports